/**
 * 变量定义:标识变量的信息（变量名+变量分组名+数据源编号）
 */
export class VariableDefinition {
    constructor(name, groupName, dataSourceCode, variableVersion) {
        this.name = name;
        this.groupName = groupName;
        this.dataSourceCode = dataSourceCode;
        this.variableVersion = variableVersion;
        this.groupName = groupName ? groupName : undefined;
        this.dataSourceCode = dataSourceCode ? dataSourceCode : 0;
        this.variableVersion = variableVersion ? variableVersion : undefined;
    }
}
